/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const TicketStatus = {
    Pending: 'PENDING',
    Running: 'RUNNING',
    Done: 'DONE',
    Failed: 'FAILED',
    Expired: 'EXPIRED'
} as const;
export type TicketStatus = typeof TicketStatus[keyof typeof TicketStatus];


export function instanceOfTicketStatus(value: any): boolean {
    for (const key in TicketStatus) {
        if (Object.prototype.hasOwnProperty.call(TicketStatus, key)) {
            if (TicketStatus[key as keyof typeof TicketStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TicketStatusFromJSON(json: any): TicketStatus {
    return TicketStatusFromJSONTyped(json, false);
}

export function TicketStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): TicketStatus {
    return json as TicketStatus;
}

export function TicketStatusToJSON(value?: TicketStatus | null): any {
    return value as any;
}

export function TicketStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): TicketStatus {
    return value as TicketStatus;
}

